<template>
  <div class="page summary-container">
    <!-- <LayoutContainer> -->
      <div class="page-content">
        <EmptyMessage>
          <span slot="icon"><img src="@/assets/image/explore.png"/></span>
          <h1 slot="title" class="title">ไม่พบหน้านี้ :(</h1>
          <p>ลองตรวจสอบ URL ที่เข้าใช้งานอีกครั้ง หรือ<router-link :to="'/'">กลับไปหน้าแรก</router-link></p>
        </EmptyMessage>
      </div>
    <!-- </LayoutContainer> -->
  </div>
</template>

<script>
// import LayoutContainer from '@/layout/LayoutContainer.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';

export default {
  components: {
    // LayoutContainer,
    EmptyMessage,
  },
  computed: {
    teamName() {
      return this.$route.params.teamName;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/variables.scss';
@import '~@/assets/scss/themes/components/page.scss';

img {
  filter: grayscale(100%);
}

</style>
